import React from 'react';
import {
    List,
    SingleFieldList,
    ChipField,
    Pagination,
    Datagrid,
    TextField,
    ReferenceArrayField,
    Edit,
    EditButton,
    DeleteButton,
    SimpleForm,
    TextInput,
    SelectArrayInput,
    ReferenceArrayInput,
    Create,
    BooleanField,
    BooleanInput,
    TopToolbar,
    FilterButton,
    CreateButton,
} from 'react-admin';
import { CustomExport } from './CustomExport';

const w100 = {
    width: "100%"
};

const llmListFilter = [
    <ReferenceArrayInput style={w100} label="Country" source="country" reference="countries" ><SelectArrayInput><ChipField source="name" alwaysOn /></SelectArrayInput></ReferenceArrayInput>,
    <ReferenceArrayInput style={w100} label="Segment" source="segment" reference="HEXSelector/LocalLicenseManagers/Segments" ><SelectArrayInput><ChipField source="name" alwaysOn /></SelectArrayInput></ReferenceArrayInput>,
    <BooleanInput label="Include Fallback" source="isGlobalFallback" defaultValue={false} alwaysOn />,
];


const LlmActions = (props) => (
    <TopToolbar>
        <FilterButton />
        <CreateButton />
        <CustomExport endPoint="/DataExport/Llm" filename="llm" filter={[]} />
    </TopToolbar>
);

export const LLMList = (props) => {
    return (
        <List title="Local License Managers" {...props} filters={llmListFilter} pagination={<Pagination rowsPerPageOptions={[10, 25, 100, 500]}></Pagination>} actions={<LlmActions />} sort={{ field: 'name', order: 'ASC' }}>
        <Datagrid>
            <TextField label="Name" source="name" />
            <TextField label="Email" source="email" />
            <ReferenceArrayField label="Countries" source="country_ids" reference="countries">
                <SingleFieldList>
                    <ChipField source="name" />
                </SingleFieldList>                        
            </ReferenceArrayField>
            <ReferenceArrayField label="Segments" source="segment_ids" reference="HEXSelector/LocalLicenseManagers/Segments">
                <SingleFieldList>
                    <ChipField source="name" />
                </SingleFieldList>                        
            </ReferenceArrayField>
            <BooleanField label="Global Fallback" source="isGlobalFallback" />
            <EditButton></EditButton>
            <DeleteButton></DeleteButton>
        </Datagrid>
    </List>
    );
}

export const LLMEdit = (props) => (
    <Edit {...props}>
        <SimpleForm>
            <TextInput label="Name" source="name"></TextInput>
            <TextInput label="Email" source="email"></TextInput>
            <ReferenceArrayInput label="Countries" source="country_ids" reference="countries">
                <SelectArrayInput>
                   <ChipField source="name" />
                </SelectArrayInput>
            </ReferenceArrayInput>
            <ReferenceArrayInput label="Segments" source="segment_ids" reference="HEXSelector/LocalLicenseManagers/Segments">
                <SelectArrayInput>
                   <ChipField source="name" />
                </SelectArrayInput>
            </ReferenceArrayInput>
            <ReferenceArrayInput label="Allowed Licenses" source="allowedSegments_ids" reference="HEXSelector/SegmentCollections" perPage={1000}>
                <SelectArrayInput>
                    <ChipField source="name" />
                </SelectArrayInput>
            </ReferenceArrayInput>
            <ReferenceArrayInput label="Allowed Delivery Concepts" source="allowedDeliveryConcepts_ids" reference="HEXSelector/RegionalSettings/DeliveryConcepts" perPage={1000}>
                <SelectArrayInput>
                    <ChipField source="name" />
                </SelectArrayInput>
            </ReferenceArrayInput>
            <ReferenceArrayInput label="Allowed Custom Portfolios" source="allowedCustomPortfolios_ids" reference="HEXSelector/RegionalSettings/CustomPortfolios" perPage={1000}>
                <SelectArrayInput>
                    <ChipField source="name" />
                </SelectArrayInput>
            </ReferenceArrayInput>
            <ReferenceArrayInput label="Allowed Local Price Lists" source="allowedPriceLists_ids" reference="HEXSelector/RegionalSettings/LocalPriceLists" perPage={1000}>
                <SelectArrayInput>
                    <ChipField source="name" />
                </SelectArrayInput>
            </ReferenceArrayInput>
             <BooleanInput label="Fallback" source="isGlobalFallback" />
        </SimpleForm>
    </Edit>
);

export const LLMCreate = (props) => (
    <Create {...props}>
        <SimpleForm>
            <TextInput label="Name" source="name"></TextInput>
            <TextInput label="Email" source="email"></TextInput>
            <ReferenceArrayInput label="Countries" source="country_ids" reference="countries">
                <SelectArrayInput>
                   <ChipField source="name" />
                </SelectArrayInput>
            </ReferenceArrayInput>
            <ReferenceArrayInput label="Segments" source="segment_ids" reference="HEXSelector/LocalLicenseManagers/Segments">
                <SelectArrayInput>
                   <ChipField source="name" />
                </SelectArrayInput>
            </ReferenceArrayInput>
            <ReferenceArrayInput label="Allowed Licenses" source="allowedSegments_ids" reference="HEXSelector/SegmentCollections" perPage={1000}>
                <SelectArrayInput>
                    <ChipField source="name" />
                </SelectArrayInput>
            </ReferenceArrayInput>
            <ReferenceArrayInput label="Allowed Delivery Concepts" source="allowedDeliveryConcepts_ids" reference="HEXSelector/RegionalSettings/DeliveryConcepts" perPage={1000}>
                <SelectArrayInput>
                    <ChipField source="name" />
                </SelectArrayInput>
            </ReferenceArrayInput>
            <ReferenceArrayInput label="Allowed Custom Portfolios" source="allowedCustomPortfolios_ids" reference="HEXSelector/RegionalSettings/CustomPortfolios" perPage={1000}>
                <SelectArrayInput>
                    <ChipField source="name" />
                </SelectArrayInput>
            </ReferenceArrayInput>
            <ReferenceArrayInput label="Allowed Local Price Lists" source="allowedPriceLists_ids" reference="HEXSelector/RegionalSettings/LocalPriceLists" perPage={1000}>
                <SelectArrayInput>
                    <ChipField source="name" />
                </SelectArrayInput>
            </ReferenceArrayInput>
            <BooleanInput source="isGlobalFallback" />
        </SimpleForm>
    </Create>
);